import { getScriptPath } from 'owa-config';

// Bootstrap the public path before webpack tries to load anything that depends on it.
if (process.env.IS_WEBPACK) {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getScriptPath called at module scope is not allowed. This may cause unwanted side effects. */
    __webpack_public_path__ = getScriptPath();
}
